var pi = Math.PI,
    halfPi = pi / 2;
export function sinIn(t) {
  return +t === 1 ? 1 : 1 - Math.cos(t * halfPi);
}
export function sinOut(t) {
  return Math.sin(t * halfPi);
}
export function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-ease/src/sin.js
// module id = 235
// module chunks = 0 1 2